import React, { useEffect, useState } from "react";
import AppWrapper from "../AppWrapper";
import {
  Page,
  Card,
  DataTable,
  Spinner,
  Text,
  BlockStack,
} from "@shopify/polaris";
import supabase from "../../supabase-client";

function AfirmePayments() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPayments = async () => {
      const { data, error } = await supabase
        .from("afirme_payments")
        .select("*")
        .order("id", { ascending: false });

      if (error) {
        console.error("Error loading Afirme payments:", error);
        setLoading(false);
        return;
      }

      // Format DataTable rows
      const formatted = data.map((row) => [
        new Date(row.created_at).toLocaleString("es-MX"),
        row.concepto || "",
        row.cantidad !== null ? "$" + row.cantidad.toLocaleString("es-MX") : "",
        row.folio || "",
        row.clave_seguimiento || "",
      ]);

      setRows(formatted);
      setLoading(false);
    };

    loadPayments();
  }, []);

  return (
    <AppWrapper>
      <Page title="Pagos Afirme">
        <Card>
          {loading ? (
            <BlockStack align="center" inlineAlign="center" padding="500">
              <Spinner size="large" />
              <Text variant="bodyMd" tone="subdued">
                Cargando...
              </Text>
            </BlockStack>
          ) : (
            <DataTable
              columnContentTypes={[
                "text", // created_at
                "text", // concepto
                "numeric", // cantidad
                "text", // folio
                "text", // clave_seguimiento
              ]}
              headings={[
                "Fecha",
                "Concepto",
                "Cantidad",
                "Folio",
                "Clave Seguimiento",
              ]}
              rows={rows}
            />
          )}
        </Card>
      </Page>
    </AppWrapper>
  );
}

export default AfirmePayments;
